module.exports = __webpack_public_path__ + "static/media/casas_bolsa.7f62549b.svg";